import React, { useEffect } from "react";
import {
  FormGroup,
  LabelForm,
  FormGroupVerticalInput,
  CheckboxInput,
  SearchGroups,
} from "..";
import { getInputErrorMessage } from "../../utils";

const SearchPanelMachineMaster = ({
  groupSettings,
  errors,
  dataSearch,
  setDataSearch,
  inputOptions,
  statusCheckbox,
  setStatusCheckbox,
  handleSelectChange,
}) => {
  useEffect(() => {
    let status = "";
    if (statusCheckbox.active && statusCheckbox.inactive) {
      status = "active,inactive";
    } else if (statusCheckbox.active) {
      status = "active";
    } else if (statusCheckbox.inactive) {
      status = "inactive";
    }
    setDataSearch({ ...dataSearch, status: status });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCheckbox]);

  return (
    <>
      <SearchGroups
        groupSettings={groupSettings}
        errors={errors}
        inputOptions={inputOptions}
        dataSearch={dataSearch}
        handleSelectChange={handleSelectChange}
      />
      <FormGroup direction="horizontal">
        <LabelForm
          text="状態"
          required
          className="lg:min-w-[248px] min-w-[232px]"
        />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "status")}>
          <div className="flex flex-row xl:space-x-[72px] space-x-[64px]">
            <CheckboxInput
              id="active"
              name="active"
              label="有効"
              onChange={() =>
                setStatusCheckbox({
                  ...statusCheckbox,
                  active: !statusCheckbox.active,
                })
              }
              checked={statusCheckbox.active}
            />
            <CheckboxInput
              id="inactive"
              name="inactive"
              label="無効"
              onChange={() =>
                setStatusCheckbox({
                  ...statusCheckbox,
                  inactive: !statusCheckbox.inactive,
                })
              }
              checked={statusCheckbox.inactive}
            />
          </div>
        </FormGroupVerticalInput>
      </FormGroup>
    </>
  );
};

export default SearchPanelMachineMaster;
